import React, { useState, useEffect } from "react";
import axiosInstance from "../../utils/axiosInstance";
import { FaEdit } from "react-icons/fa";
import logo from "../../Assets/logo.jpg"; 
import "./VendorManager.css";

const VendorManager = () => {
  const [vendors, setVendors] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    wallet: 0,
  });
  const [editMode, setEditMode] = useState(false);
  const [selectedVendorId, setSelectedVendorId] = useState(null);

  useEffect(() => {
    fetchVendors();
  }, []);

  const fetchVendors = async () => {
    try {
      const res = await axiosInstance.get("/vendor");
      setVendors(res.data);
    } catch (error) {
      console.error("Error fetching vendors:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name) return alert("Name is required");
    if (!editMode) return alert("Select a vendor to edit");

    try {
      await axiosInstance.put(`/vendor/${selectedVendorId}`, formData);
      alert("Vendor updated successfully!");

      setFormData({ name: "", wallet: 0 });
      setEditMode(false);
      setSelectedVendorId(null);
      fetchVendors();
    } catch (error) {
      alert(error.response?.data?.message || "Error updating vendor");
    }
  };

  const handleEdit = (vendorId) => {
    const vendor = vendors.find((v) => v._id === vendorId);
    if (vendor) {
      setFormData({
        name: vendor.name,
        wallet: vendor.wallet || 0,
      });
      setEditMode(true);
      setSelectedVendorId(vendorId);
    }
  };

  return (
    <div className="vendor-container">
      <h2>✏️ Edit Vendor</h2>

      {/* Edit form */}
      <form onSubmit={handleSubmit} className="vendor-form">
        <div className="input-group">
          <label>Name</label>
          <input
            type="text"
            name="name"
            placeholder="Vendor Name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>

        <div className="input-group">
          <label>Wallet</label>
          <div style={{ display: "flex", alignItems: "center" }}>
            <img
              src={logo}
              alt="coin"
              style={{
                width: "18px",
                height: "18px",
                borderRadius: "50%",
                marginRight: "6px",
                objectFit: "cover",
                boxShadow: "0 1px 2px rgba(0,0,0,0.25)",
              }}
            />
            <input
              type="number"
              name="wallet"
              placeholder="Wallet Amount"
              value={formData.wallet}
              onChange={handleChange}
              min="0"
            />
          </div>
        </div>

        <button type="submit" className="submit-btn">
          Update Vendor
        </button>
      </form>

      {/* Vendor List Table */}
      <h3>📋 Vendor List</h3>
      <table className="vendor-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Business</th>
            <th>Email</th>
            <th>Contact</th>
            <th>Wallet</th>
            <th>Address</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {vendors.length > 0 ? (
            vendors.map((vendor) => (
              <tr key={vendor._id}>
                <td>{vendor.name}</td>
                <td>{vendor.businessName}</td>
                <td>{vendor.email}</td>
                <td>{vendor.contactNumber}</td>
                <td>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      src={logo}
                      alt="coin"
                      style={{
                        width: "16px",
                        height: "16px",
                        borderRadius: "50%",
                        marginRight: "4px",
                        objectFit: "cover",
                        boxShadow: "0 1px 2px rgba(0,0,0,0.25)",
                      }}
                    />
                    {vendor.wallet}
                  </div>
                </td>
                <td>
                  {vendor.address
                    ? `${vendor.address.street || ""}, ${vendor.address.city || ""}, ${vendor.address.state || ""} - ${vendor.address.pincode || ""}`
                    : ""}
                </td>
                <td>
                  <button
                    className="edit-btn"
                    onClick={() => handleEdit(vendor._id)}
                  >
                    <FaEdit /> Edit
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="7" className="empty">
                No vendors found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default VendorManager;